<template>
  <v-card v-if="payRun" :loading="loading || pdfDownloadLoading" :disabled="loading || pdfDownloadLoading">
    <div ref="pdfZone">
      <v-card-title>
        <v-row no-gutters>
          <span> PayRun Detail</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close" fab class="error" x-small>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text class="page-content">
        <v-row>
          <v-col md="9" style="font-size: 20px" class="pt-12">
            <strong :class="{ 'blue--text': !isDarkTheme, text_white: isDarkTheme }"> {{ payRun.TeamMember?.Name }}</strong>
          </v-col>
          <v-col class="text-right pdf-ignore" md="3"><img src="../../assets/images/code-clan-logo.png" style="width: 100%" /></v-col>
        </v-row>
        <v-row>
          <v-col md="12" cols="12"> <b>Duration:</b> {{ formatDate(payRun.FromDate) }} ~ {{ formatDate(payRun.ToDate) }} </v-col>
        </v-row>
        <v-row>
          <v-col md="12" cols="12" class="payrun-table">
            <table class="tbl" cellspacing="1" cellpadding="5">
              <thead>
                <tr>
                  <th>Date / Commitment</th>
                  <th v-for="(w, index) in splitWeeks" :key="index">Week{{ index + 1 }}</th>
                  <th>Total Hours</th>
                  <th>Adjustment (hours)</th>
                  <th>Performance coefficient</th>
                  <th style="width: 100px">Total Pay</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tmPayRunItems" :key="`${index}-commitments-${item.Commitment && item.Commitment.id}`">
                  <td>
                    {{ item.Commitment && item.Commitment?.Name }}
                  </td>
                  <td v-for="(w, index) in item.Weeks" :key="index">{{ w.Hours }}</td>
                  <td>
                    {{ item.TotalHours }}
                  </td>
                  <td>
                    {{ item.AdjustmentHours }}
                  </td>
                  <td>
                    {{ item.SeniorityLevel }}
                  </td>
                  <td>{{ item.TotalPay }} AUD</td>
                </tr>
                <tr>
                  <td>SUM</td>
                  <td v-for="(w, index) in splitWeeks" :key="w.from">
                    {{ getSumTimesheetOfWeek(index) }}
                  </td>
                  <td>
                    {{ sumTotalHours }}
                  </td>
                  <td>
                    {{ sumAdjustments }}
                  </td>
                  <td>-</td>
                  <td>{{ sumTotalPay }} AUD</td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="page-content" v-if="lmPayRunItems && lmPayRunItems.length > 0">
        <v-row>
          <v-col md="12" cols="12"> <b>Line Manager Payments: </b></v-col>
          <br />
          <v-col md="12" cols="12" class="payrun-table">
            <table class="tbl" cellspacing="1" cellpadding="5">
              <thead>
                <tr>
                  <th>Date / Commitment</th>
                  <th v-for="(w, index) in splitWeeks" :key="index">Week{{ index + 1 }}</th>
                  <th>Total Hours</th>
                  <th>Adjustment (hours)</th>
                  <th>Performance coefficient</th>
                  <th style="width: 100px">Total Pay</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in lmPayRunItems" :key="`${index}-lm-commitments-${item.Commitment && item.Commitment.id}`">
                  <td>
                    {{ item.Commitment && item.Commitment?.Name }}
                  </td>
                  <td v-for="(w, index) in item.Weeks" :key="index">{{ w.Hours }}</td>
                  <td>
                    {{ item.TotalHours }}
                  </td>
                  <td>
                    {{ item.AdjustmentHours }}
                  </td>
                  <td>
                    {{ item.SeniorityLevel }}
                  </td>
                  <td>{{ item.TotalPay }} AUD</td>
                </tr>
                <tr>
                  <td>SUM</td>
                  <td v-for="(w, index) in splitWeeks" :key="w.from">
                    {{ lmGetSumTimesheetOfWeek(index) }}
                  </td>
                  <td>
                    {{ lmSumTotalHours }}
                  </td>
                  <td>
                    {{ lmSumAdjustments }}
                  </td>
                  <td>-</td>
                  <td>{{ lmSumTotalPay }} AUD</td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="page-content">
        <v-row>
          <v-col md="6" sm="6" cols="12">
            <v-row>
              <v-col md="8" sm="8" cols="8">Admin Approved Payrun:</v-col>
              <v-col md="4" sm="4" cols="4" class="text-right"
                ><span class="card pl-0 pr-0"
                  >{{
                    payrunAuditTrailDetail && payrunAuditTrailDetail[0] && payrunAuditTrailDetail[0].AdminApprovedDate
                      ? payrunAuditTrailDetail[0].AdminApprovedDate
                      : "Not approved"
                  }}
                </span></v-col
              >
              <v-col md="12" sm="12" cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="8" sm="12" cols="8">Team Member Approved Payrun:</v-col>
              <v-col md="4" sm="12" cols="4" class="text-right"
                ><span class="card pl-0 pr-0"
                  >{{
                    payrunAuditTrailDetail && payrunAuditTrailDetail[0] && payrunAuditTrailDetail[0].TMApprovedDate
                      ? payrunAuditTrailDetail[0].TMApprovedDate
                      : "Not approved"
                  }}
                </span></v-col
              >
              <v-col md="12" sm="12" cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="6" sm="6" cols="0">
            <v-row v-for="(ad, idx) in AuAdjustments" :key="'aud_adj_' + idx">
              <v-col md="6" sm="6" cols="7">
                Adjustments AUD <br />
                <small> {{ ad.description }}</small>
              </v-col>
              <v-col md="6" sm="6" cols="5" class="text-right">
                <span class="card">{{ ad.adjustment }} AUD</span>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <div v-if="AuLoanItems">
              <v-row v-for="(ad, idx) in AuLoanItems.filter((c) => !c.IsDeleted)" :key="'aud_loan_' + idx">
                <v-col md="6" sm="6" cols="7">
                  Loan Adjustment AUD <br />
                  <small> {{ ad.Description }}</small>
                </v-col>
                <v-col md="6" sm="6" cols="5" class="text-right">
                  <span class="card">{{ ad.Amount }} AUD</span>
                </v-col>
                <v-col md="12" sm="12" cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </div>
            <v-row class="pt-3">
              <v-col md="6" sm="6" cols="7"> Exchange rate {{ exchangeCurrencyId }}<br /> </v-col>
              <v-col md="6" sm="6" cols="5" class="text-right">
                <span class="card">{{ payRun.ExchangeRate }}</span>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row v-for="(ad, idx) in secondaryAdjustments" :key="'secondary_adj _' + idx">
              <v-col md="6" sm="6" cols="7">
                Adjustments {{ exchangeCurrencyId }} <br />
                <small> {{ ad.description }}</small>
              </v-col>
              <v-col md="6" sm="6" cols="5" class="text-right">
                <span class="card">{{ ad.adjustment }} {{ exchangeCurrencyId }}</span>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" sm="6" cols="7"> <b>Total pay AUD</b> </v-col>
              <v-col md="6" sm="6" cols="5" class="text-right">
                <span class="card blue text_white">{{ formatNumber(payRun.AUDTotalPay) }} AUD</span>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" sm="6" cols="7">
                <b>Total pay {{ exchangeCurrencyId }}</b>
              </v-col>
              <v-col md="6" sm="6" cols="5" class="text-right">
                <span class="card blue text_white">{{ formatNumber(payRun.LCTotalPay) }} {{ exchangeCurrencyId }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="payRun.Payments && payRun.Payments.length > 0">
          <v-col md="12" cols="12"> <b>Payment History</b> </v-col>
          <v-col>
            <v-data-table :hide-default-footer="true" class="pt-0 payRunActivityList" :items="payRun.Payments" :headers="headers">
              <template v-slot:item.LCTotalPay="{ item }">
                <strong>{{ formatNumber(item.LCTotalPay) }} {{ exchangeCurrencyId }}</strong>
              </template>
              <template v-slot:item.PaymentDate="{ item }">
                <strong>{{ formatDate(item.PaymentDate) }}</strong>
              </template>
              <template v-slot:item.PaymentRefNo="{ item }">
                <strong>{{ item.PaymentRefNo }}</strong>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
    <v-card-actions class="action-bottons">
      <div class="d-flex flex-wrap flex-column flex-md-row-reverse ml-auto mr-auto mr-md-1 gap-10px">
        <v-btn class="primary_btn" v-if="!isForAdmin && payRun.AdminApproved && !payRun.TMApproved" @click="confirmedByTm()"
          ><v-icon>mdi-check-all</v-icon> Approve</v-btn
        >
        <v-btn text @click="close"><v-icon>mdi-close</v-icon> Close</v-btn>
        <v-btn color="primary" @click="downloadPDF"><v-icon>mdi-printer</v-icon> Download PDF</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import PayRun, { Adjustment, PayRunItem, WeekRange } from "../../models/PayRun";
import Utils from "../../utils/Utils";
import PayRunService from "../../services/PayRunService";
import { LoanItem } from "../../models/Loan";
import { Currencies } from "../../definitions/constants";
import { PayRunAuditTrail } from "../../models/AuditTrail";
const { jsPDF } = require("jspdf");

export default defineComponent({
  props: {
    payrunAuditTrail: {
      type: Object as () => PayRunAuditTrail,
      required: false,
    },
    model: {
      type: Object as () => PayRun,
      required: true,
    },
    isForAdmin: {
      type: Boolean,
      required: false,
    },
    isForTeammember: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      mainCurrency: Currencies.find((x) => x.isMain),
      payRun: undefined as PayRun | undefined,
      payrunAuditTrailDetail: [] as PayRunAuditTrail[],
      loading: false,
      pdfDownloadLoading: false,
      tmPayRunItems: [] as PayRunItem[],
      lmPayRunItems: [] as PayRunItem[],
      headers: [
        { title: "Total payments", align: "center", value: "LCTotalPay", sortable: false },
        { title: "Payment dates", align: "center", value: "PaymentDate", sortable: false },
        { title: "Payment reference", align: "center", value: "PaymentRefNo", sortable: false },
      ],
    };
  },
  methods: {
    close(): void {
      this.$emit("close");
    },
    downloadPDF() {
      this.pdfDownloadLoading = true;
      this.populatePDF()
        .then(() => {
          this.close();
        })
        .finally(() => {
          this.pdfDownloadLoading = false;
        });
    },
    populatePDF() {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (this.$refs.pdfZone) {
            const pdfDocHeight = 1150;
            // Access the HTML element and do something with it
            const elementToPrint = this.$refs.pdfZone as HTMLElement;
            const pageContents = document.getElementsByClassName("page-content");
            if (pageContents && pageContents.length) {
              for (let index = 0; index < pageContents.length; index++) {
                const pageContent = pageContents[index] as HTMLElement;
                if (pageContent && index < pageContents.length - 1) {
                  const pageContentHeight = pageContent.clientHeight;
                  const multiple = pdfDocHeight > pageContentHeight ? 1 : parseInt((pageContentHeight / pdfDocHeight).toString()) + 1;
                  const minHeight = multiple * pdfDocHeight;
                  pageContent.style.minHeight = `${minHeight}px`;
                }
              }
            }

            // Convert the element to a canvas and add it to the PDF
            const pdf = new jsPDF("p", "pt", "a4");

            pdf.html(elementToPrint, {
              windowWidth: 800,
              width: 600,
              autoPaging: true,
              callback: (pdf: any) => {
                pdf.save("PayRun.pdf");
                this.pdfDownloadLoading = false;
                resolve("resolved");
              },
            });
          }
        }, 2000);
      });
    },
    confirmedByTm(): void {
      this.loading = true;
      if (this.payRun) {
        this.$emit("approveByTM", this.payRun);
        this.loading = false;
      }
    },
    formatNumber(value: number): string {
      return Utils.moneyFormat(value);
    },
    lmGetSumTimesheetOfWeek(index: number): number {
      if (this.lmPayRunItems) {
        let retVal = 0;
        this.lmPayRunItems.forEach((item) => {
          if (item.Weeks[index] && item.Weeks[index].Hours) {
            retVal += item.Weeks[index].Hours;
          }
        });
        return retVal;
      } else {
        return 0;
      }
    },

    getSumTimesheetOfWeek(index: number): number {
      if (this.tmPayRunItems) {
        let retVal = 0;
        this.tmPayRunItems.forEach((item) => {
          if (item.Weeks[index] && item.Weeks[index].Hours) {
            retVal += item.Weeks[index].Hours;
          }
        });
        return retVal;
      } else {
        return 0;
      }
    },
    formatDate(dt: any): string {
      if (dt) {
        return Utils.toVsDateFormat(dt);
      } else {
        return "Not set";
      }
    },
    setPayRunAuditTrailDetail(audit: PayRunAuditTrail) {
      this.payrunAuditTrailDetail = [];
      if (audit && (audit.AdminApprovedDate || audit.PaymentRefAddedDate || audit.TMApprovedDate)) {
        this.payrunAuditTrailDetail.push(audit);
      }
    },
  },
  computed: {
    exchangeCurrencyId(): string {
      return PayRunService.getPayRunExchangeCurrency(this.payRun);
    },
    mainCurrencyId(): string {
      return this.mainCurrency ? this.mainCurrency.id : "";
    },
    AuLoanItems(): LoanItem[] {
      if (this.payRun) {
        return this.payRun.LoanItems;
      }
      return [];
    },
    AuAdjustments(): Adjustment[] {
      if (this.payRun && this.payRun.Adjustments) {
        return this.payRun.Adjustments.filter((ad) => ad.type === this.mainCurrencyId);
      }
      return [];
    },
    secondaryAdjustments(): Adjustment[] {
      if (this.payRun && this.payRun.Adjustments) {
        return this.payRun.Adjustments.filter((ad) => ad.type !== this.mainCurrencyId && ad.type === this.exchangeCurrencyId);
      }
      return [];
    },
    lmSumTotalHours(): number {
      if (this.lmPayRunItems) {
        let retVal = 0;
        this.lmPayRunItems.forEach((item) => (retVal += item.TotalHours));
        return retVal;
      } else {
        return 0;
      }
    },
    lmSumAdjustments(): number {
      if (this.lmPayRunItems) {
        let retVal = 0;
        this.lmPayRunItems.forEach((item) => (retVal += item.AdjustmentHours));
        return retVal;
      } else {
        return 0;
      }
    },
    lmSumTotalPay(): number {
      if (this.lmPayRunItems) {
        let retVal = 0;
        this.lmPayRunItems.forEach((item) => (retVal += item.TotalPay));
        return retVal;
      } else {
        return 0;
      }
    },

    splitWeeks(): WeekRange[] {
      if (this.payRun) {
        return Utils.getSplittedWeeks(this.payRun.FromDate, this.payRun.ToDate);
      }
      return [];
    },
    sumTotalHours(): number {
      if (this.tmPayRunItems) {
        let retVal = 0;
        this.tmPayRunItems.forEach((item) => (retVal += item.TotalHours));
        return retVal;
      } else {
        return 0;
      }
    },
    sumAdjustments(): number {
      if (this.tmPayRunItems) {
        let retVal = 0;
        this.tmPayRunItems.forEach((item) => (retVal += item.AdjustmentHours));
        return retVal;
      } else {
        return 0;
      }
    },
    sumTotalPay(): number {
      if (this.tmPayRunItems) {
        let retVal = 0;
        this.tmPayRunItems.forEach((item) => (retVal += item.TotalPay));
        return retVal;
      } else {
        return 0;
      }
    },
    isDarkTheme() {
      return this.$vuetify.theme.current.dark;
    },
  },
  watch: {
    payrunAuditTrail(newVal) {
      this.setPayRunAuditTrailDetail(newVal);
    },
  },
  mounted() {
    this.payRun = this.model;
    if (this.payRun && this.payRun.Items) {
      this.tmPayRunItems = this.payRun.Items.filter((c) => !c.PayrunItemType || c.PayrunItemType !== "LineManager");
      this.lmPayRunItems = this.payRun.Items.filter((c) => c.PayrunItemType && c.PayrunItemType === "LineManager");
    }

    if (this.payrunAuditTrail) {
      this.setPayRunAuditTrailDetail(this.payrunAuditTrail);
    }
  },
});
</script>
<style lang="scss" scoped>
.payrun-table {
  overflow-x: scroll;
}
.payRunActivityList {
  width: 100%;
}
.v-theme--dark {
  table.tbl {
    thead {
      tr {
        th {
          background: #555;
        }
      }
    }
    tbody {
      tr {
        td {
          background: rgb(129, 128, 128);
          &:first-child {
            background: #555;
          }
        }
      }
    }
  }
}
table.tbl {
  border: 1px solid silver;
  background: #888;
  border: 1px soliver silver;
  width: 100%;
  border-radius: 5px;
  thead {
    tr {
      th {
        padding: 5px;
        background: rgb(219, 228, 247);
      }
    }
  }
  tbody {
    tr {
      td {
        padding: 5px;
        background: #fff;
        vertical-align: middle;
        text-align: center;

        &:first-child {
          background: rgb(219, 228, 247);
          font-weight: 600;
        }
      }
    }
  }
}
span.card {
  display: inline-block;
  width: 100px;
  border: 1px solid #555;
  padding: 5px;
  text-align: center;
  font-weight: 600;
}

.page-break {
  page-break-before: always;
}
@media (max-width: 960px) {
  .action-bottons {
    height: auto !important;
  }
}
</style>
